import { createValidatorConverter } from 'src/services/database/utils';
import { WorkspaceDto } from 'src/services/database/Workspaces/dto/workspace.dto';

export const WorkspaceConverter = createValidatorConverter(WorkspaceDto, {
  useFirestoreTimestamp: true,
});
